import { sortFixturesChronological, sortGameResultsRecentFirst } from '@/helpers';
import type { Fixture } from '@/models/fixture';
import type { gameResult } from '@/models/gameUpdate';

export function groupFixturesByMatchday(list: Fixture[]): { matchday: number; fixtures: Fixture[] }[] {
  const sorted = [...list].sort((a, b) => {
    const ma = a.matchday ?? 0;
    const mb = b.matchday ?? 0;
    if (ma !== mb) return ma - mb;
    return sortFixturesChronological(a, b);
  });
  const groups: { matchday: number; fixtures: Fixture[] }[] = [];
  for (const f of sorted) {
    const md = f.matchday ?? 0;
    const last = groups[groups.length - 1];
    if (last && last.matchday === md) {
      last.fixtures.push(f);
    } else {
      groups.push({ matchday: md, fixtures: [f] });
    }
  }
  return groups;
}

export function groupResultsByMatchday(list: gameResult[]): { matchday: number; results: gameResult[] }[] {
  const byMatchday = new Map<number, gameResult[]>();
  for (const r of list) {
    const md = r.matchday ?? 0;
    const group = byMatchday.get(md);
    if (group) group.push(r);
    else byMatchday.set(md, [r]);
  }
  return [...byMatchday.entries()]
    .sort(([a], [b]) => b - a)
    .map(([matchday, results]) => ({
      matchday,
      results: sortGameResultsRecentFirst(results),
    }));
}
